import {mapState} from 'vuex';

export default {
    data:() =>({
        keyword: ''
    }),
    computed:{
        ...mapState('setting', {
            rooms: state => state.rooms
        }),
    },
    methods:{
    }
}
